// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterTag {
  width: 120px !important;
}

.select-sm {
  height: calc(1.75rem + 2px) !important;
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
  border-radius: 3px;
  z-index: 100 !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/contact.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;AACzB","sourcesContent":[".filterTag {\r\n  width: 120px !important;\r\n}\r\n\r\n.select-sm {\r\n  height: calc(1.75rem + 2px) !important;\r\n  padding: 0.25rem 1rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1.25rem;\r\n  border-radius: 3px;\r\n  z-index: 100 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
